import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';

const [
  LIST_PROJECT_INIT_BUY_TAXBILLS,
  LIST_PROJECT_INIT_BUY_TAXBILLS_SUCCESS,
  LIST_PROJECT_INIT_BUY_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_INIT_BUY_TAXBILLS');

export const listProjectInitBuyTaxbills = createAction(
  LIST_PROJECT_INIT_BUY_TAXBILLS,
  (id) => id,
);
const listProjectInitBuyTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_INIT_BUY_TAXBILLS,
  taxbillApi.getProjectInitBuyTaxbill,
);

const [
  LIST_PROJECT_INIT_SALES_TAXBILLS,
  LIST_PROJECT_INIT_SALES_TAXBILLS_SUCCESS,
  LIST_PROJECT_INIT_SALES_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_INIT_SALES_TAXBILLS');

export const listProjectInitSalesTaxbills = createAction(
  LIST_PROJECT_INIT_SALES_TAXBILLS,
  (id) => id,
);
const listProjectInitSalesTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_INIT_SALES_TAXBILLS,
  taxbillApi.getProjectInitSalesTaxbill,
);

// 세금 계산서 매출 발행 예정 리스트

const [
  LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN,
  LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN_SUCCESS,
  LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN');

export const listProjectInitSalesTaxbillsPlan = createAction(
  LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN,
  (id) => id,
);
const listProjectInitSalesTaxbillsPlanSaga = createRequestSaga(
  LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN,
  taxbillApi.getProjectInitSalesTaxbillPlan,
);

const [
  LIST_PROJECT_BUY_TAXBILLS,
  LIST_PROJECT_BUY_TAXBILLS_SUCCESS,
  LIST_PROJECT_BUY_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_BUY_TAXBILLS');

export const listProjectBuyTaxbills = createAction(
  LIST_PROJECT_BUY_TAXBILLS,
  (id) => id,
);
const listProjectBuyTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_BUY_TAXBILLS,
  taxbillApi.getIssuedBuyTaxbills,
);

const [
  LIST_PROJECT_SALES_TAXBILLS,
  LIST_PROJECT_SALES_TAXBILLS_SUCCESS,
  LIST_PROJECT_SALES_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_SALES_TAXBILLS');

export const listProjectSalesTaxbills = createAction(
  LIST_PROJECT_SALES_TAXBILLS,
  (id) => id,
);
const listProjectSalesTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_SALES_TAXBILLS,
  taxbillApi.getIssuedSalesTaxbills,
);

const [
  LIST_PROJECT_BUY_PLAN,
  LIST_PROJECT_BUY_PLAN_SUCCESS,
  LIST_PROJECT_BUY_PLAN_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_BUY_PLAN');

export const listProjectBuyPlan = createAction(
  LIST_PROJECT_BUY_PLAN,
  (id) => id,
);

const listProjectBuyPlanSaga = createRequestSaga(
  LIST_PROJECT_BUY_PLAN,
  taxbillApi.getProjectBuyTaxbillPlan, 
);

const [
  SAVE_PROJECT_BUY_TAXBILL_PLAN,
  SAVE_PROJECT_BUY_TAXBILL_PLAN_SUCCESS,
  SAVE_PROJECT_BUY_TAXBILL_PLAN_FAILURE,
] = createRequestActionTypes('project/SAVE_PROJECT_BUY_TAXBILL_PLAN');

/* 2. 액션 생성 함수 */
export const saveProjectBuyTaxbillPlan = createAction(
  SAVE_PROJECT_BUY_TAXBILL_PLAN,
  (plans) => plans,
);

/* 3. 사가 생성 */
const saveProjectBuyTaxbillPlanSaga = createRequestSaga(
  SAVE_PROJECT_BUY_TAXBILL_PLAN,
  taxbillApi.postProjectBuyTaxbillPlan,
);

const UNLOAD_SAVE_RESULT = 'project/UNLOAD_SAVE_RESULT';
export const unloadSaveResult = createAction(UNLOAD_SAVE_RESULT);

// 액션 타입 추가
const UNLOAD_PURCHASE_PLANS = 'project/UNLOAD_PURCHASE_PLANS';

// 액션 생성 함수 추가
export const unloadPurchasePlans = createAction(UNLOAD_PURCHASE_PLANS);

export function* issuedTaxbillsSaga() {
  
  yield takeLatest(
    LIST_PROJECT_INIT_BUY_TAXBILLS,
    listProjectInitBuyTaxbillsSaga,
  );
  yield takeLatest(
    LIST_PROJECT_INIT_SALES_TAXBILLS,
    listProjectInitSalesTaxbillsSaga,
  );
  yield takeLatest(
    LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN,
    listProjectInitSalesTaxbillsPlanSaga,
  );
  yield takeLatest(LIST_PROJECT_BUY_TAXBILLS, listProjectBuyTaxbillsSaga);
  yield takeLatest(LIST_PROJECT_SALES_TAXBILLS, listProjectSalesTaxbillsSaga);
  //yield takeLatest(LIST_PROJECT_SALES_TAXBILLS, listProjectSalesTaxbillsSaga);

  yield takeLatest(
    LIST_PROJECT_INIT_BUY_TAXBILLS,
    listProjectInitBuyTaxbillsSaga,
  );
  yield takeLatest(
    LIST_PROJECT_INIT_SALES_TAXBILLS,
    listProjectInitSalesTaxbillsSaga,
  );
  yield takeLatest(
    LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN,
    listProjectInitSalesTaxbillsPlanSaga,
  );
  
  yield takeLatest(LIST_PROJECT_INIT_BUY_TAXBILLS, listProjectInitBuyTaxbillsSaga);
  yield takeLatest(LIST_PROJECT_BUY_PLAN, listProjectBuyPlanSaga);
    
  yield takeLatest(LIST_PROJECT_BUY_TAXBILLS, listProjectBuyTaxbillsSaga);
  yield takeLatest(LIST_PROJECT_SALES_TAXBILLS, listProjectSalesTaxbillsSaga);
  
  /* 4. 사가 등록 */
  yield takeLatest(SAVE_PROJECT_BUY_TAXBILL_PLAN, saveProjectBuyTaxbillPlanSaga);
}

const initialState = {
  // 매입
  initBuyTaxbills: null,
  // 매출
  initSalesTaxbills: null,
  // 예정
  initSalesTaxbillsPlan: null,
  initBuyTaxbills: null, 
  purchasePlans: [],
  buyTaxbills: null,
  salesTaxbills: null,
  saveResult: null, 
  error: null,
};

const issueTaxbills = handleActions(
  {
    [LIST_PROJECT_INIT_BUY_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      initBuyTaxbills: data.list.map((init) => ({
        ...init,
        buyDiv: 1,
      })),
      error: null,
    }),
    [LIST_PROJECT_INIT_BUY_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_INIT_SALES_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      initSalesTaxbills: data.list.map((init) => ({
        ...init,
        buyDiv: 1,
      })),
      error: null,
    }),
    [LIST_PROJECT_INIT_SALES_TAXBILLS_FAILURE]: (
      state,
      { payload: error },
    ) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      initSalesTaxbillsPlan: data.list.map((init) => ({
        ...init,
      })),
      error: null,
    }),
    [LIST_PROJECT_INIT_SALES_TAXBILLS_PLAN_FAILURE]: (
      state,
      { payload: error },
    ) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_BUY_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      buyTaxbills: data.list,
      error: null,
    }),
    [LIST_PROJECT_BUY_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_SALES_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      salesTaxbills: data.list,
      error: null,
    }),
    [LIST_PROJECT_SALES_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),

    [LIST_PROJECT_BUY_PLAN_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      purchasePlans: data.list,
      error: null,
    }),
    [LIST_PROJECT_BUY_PLAN_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),

    [SAVE_PROJECT_BUY_TAXBILL_PLAN_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      saveResult: data,
      error: null,
    }),
    [SAVE_PROJECT_BUY_TAXBILL_PLAN_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_SAVE_RESULT]: (state) => ({
      ...state,
      saveResult: null,
      error: null,
    }),
     [UNLOAD_PURCHASE_PLANS]: (state) => ({
      ...state,
      purchasePlans: [], // 리스트 초기화
      initBuyTaxbills: null, // 필요시 선택 목록도 초기화
      saveResult: null,
      error: null,
    }),
  },
  initialState,
);

export default issueTaxbills;
